import axios from '../../helpers/axios-setup';
import { BehalfCompany } from '../../components/pages/application/CreateApplicationPage';

export const getCompanies = () => axios.get<BehalfCompany[]>('/companies/members');
